<script>
import BOForm from '../../baseComponents/boForm'
import { SET_BOT, SUCCESS } from '../../variables'
export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'name', type: 'text', required: true }
			]
		}
	},
	methods: {
		async post() {
			this.model.bot = this.$store.getters.bot._id
			await this.axios.post('userLists', this.model)
			// dirty update of store.bot.userLists
			this.$store.dispatch(SET_BOT, this.model.bot)
			this.$emit('userListCreated')
		},
		async put() {
			await this.axios.put('userLists/' + this.model._id, this.model)
			// dirty update of store.bot.userLists
			this.$store.dispatch(SET_BOT, this.model.bot)
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/userLists/userList.form.vue